import { phoneCodes } from '@/utils/phoneCodes'

export const getPhone = (countryCode: string, phone: string) => {
  // @ts-ignore
  const phoneCode = phoneCodes[countryCode]
  const phoneOutput = phoneCode + phone

  return phoneOutput[0] !== '+' ? '+' + phoneOutput : phoneOutput
}
